<script setup>
import { useUiStore } from '@/stores/ui';

const ui = useUiStore();
</script>

<template>
  <Teleport to="body">
    <!-- aria-live: gli errori vanno annunciati, non solo mostrati. -->
    <div class="toasts" role="status" aria-live="polite">
      <TransitionGroup name="toast">
        <div v-for="message in ui.messages" :key="message.id" class="toast" :class="`toast--${message.kind}`">
          <span>{{ message.text }}</span>
          <button
            class="toast__close"
            type="button"
            :aria-label="$t('closeLabel')"
            @click="ui.dismiss(message.id)"
          >
            <svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true">
              <path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" fill="none" />
            </svg>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toasts {
  position: fixed;
  bottom: var(--s-4);
  left: 50%;
  z-index: 80;
  display: flex;
  flex-direction: column;
  gap: var(--s-2);
  translate: -50% 0;
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  max-width: min(28rem, calc(100vw - 2rem));
  padding: var(--s-3) var(--s-3) var(--s-3) var(--s-4);
  border: 1px solid var(--rule-strong);
  border-left: 3px solid var(--accent);
  border-radius: var(--radius);
  background: var(--surface-raised);
  box-shadow: var(--shadow-raised);
  font-size: var(--t-sm);
  pointer-events: auto;
}

.toast--error {
  border-left-color: var(--danger);
}

.toast__close {
  display: grid;
  place-items: center;
  padding: 2px;
  border: none;
  background: none;
  color: var(--ink-faint);
  cursor: pointer;
}

.toast__close:hover {
  color: var(--ink);
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity var(--dur) var(--ease), translate var(--dur) var(--ease);
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  translate: 0 8px;
}
</style>
